import { removeCookie } from "./cookie";

import { getDeviceInfoFromStorage,isUpThisVer } from './util';
/**
 * 消息发送 三层数据
 * def message
{
	// 基础数据
	"id": "xxx", // 需要么？
	"type": 1, // 1: text; 2: local_file; 3: 待扩展
	"text": "你好", // type为1
	"file_path": "/User/xxx/Desktop/5/aaa.pdf", // type为2

	// 结果数据
	"start_time": 1234567891011, // 开始执行时间，时间戳 ms
	"end_time": 1234567991011 // 结束执行时间，时间戳 ms
	"err_code": null, // 100:default error; 110:file copy error; 111:file not exist
}

def chat
{
	// 基础数据
	"id": "xxx", 
	"chat_name": "张星星的私聊", // 是否需要区分私聊和群聊？
	"student_name": "张星星"
	"msgs": [<message1>, <message2>, <...>],

	// 结果数据
	"start_time": 1234567891011, // 开始执行时间，时间戳 ms
	"end_time": 1234567991011 // 结束执行时间，时间戳 ms
	"err_code": null, // 200:default; 201:did not find chat name; ...
}

def task
{
	// 基础数据
	"id":"xxx",
	"name":"20231023英语班任务",
	"chats": [<chat1>, <chat2>, <...>]

	// 结果数据
	"start_time": 1234567891011, // 开始执行时间，时间戳 ms
	"end_time": 1234567991011 // 结束执行时间，时间戳 ms
	"err_code": null, // 300:default; 309:user cancel; ...
}
 */
export function sendMsgs(sendData, callback) {
  let isUp103 = isUpThisVer('1.0.3');
  console.log('isUp103',isUp103)
  if(isUp103){
    // 大于104 
    const data = JSON.stringify({
      data: {
        task:sendData,
        extra:{}
      }
    });
    window.SendMsgsModule?.sendMsgs(data, (res) => {
      callback && callback(res);
    });
  }else{
    const data = JSON.stringify({
      data: sendData
    });
    window.SendMsgsModule?.sendMsgs(data, (res) => {
      callback && callback(res);
    });
  }
  
}

export function getSendTime(sendData, callback){
  const data = JSON.stringify({
    data: sendData
  });
  console.log('getSendTime',data)
  window.SendMsgsModule?.getTaskEstimatedTime(data, (res) => {
    console.log('window.SendMsgsModule?.getTaskEstimatedTime(data, (res) ',res)
    callback && callback(res);
  });
}

/**
 *
 * 文件选择
 */
export function pickFiles(callback) {
    const data = JSON.stringify({
        data: { type: 'xml' }
      });
      console.log("调用原生应用：pickFiles")
  window.FilePickerModule?.pickFiles(data, (res) => {
    console.log('调用原生的API的回调返回内容', res);
    // if (res.code == 1) {
      callback && callback(res.paths);
    // }
  });
}

/**
 *
 * 文件夹选择
 */
export function pickFolder(callback) {
  const data = JSON.stringify({
    data: { type: 'xml' }
  });
  console.log("调用原生应用：pickFolder")
  window.FilePickerModule?.pickDirectory(data, (res) => {
    console.log('调用原生的API的回调返回内容', res);
    // if (res.code == 1) {
      callback && callback(res.paths);
    // }
  });
}

/**
 * 将用户信息发送给应用
 * {
    "staffList": [
        {
            "avatar": "",
            "nickname": "",
            "staffId": ""
        }
    ],
    "identity": 0,
    "currentStaffId": "",
    "e2mf": "",
    "e2e": "",
    "email": ""
}
 * 
 */
export function sendLoginInfoToApp(loginInfo) {
  const data = JSON.stringify({
    data: loginInfo
  });
  console.log('data:', JSON.stringify(data));
  window.LoginModule?.syncLoginInfo(data);
}

/**
 * 更新应用中存储的staffID
 * @param {*} currentStaffId
 */
export function updateCurrentStaff(currentStaffId) {
  const data = JSON.stringify({
    data: {
      currentStaffId: currentStaffId
    }
  });
  window.LoginModule?.updateCurrentStaff(data);
}

/**
 * 从应用中获取用户数据
 * @param {*} callback
 */
// TODO: fix 函数名称，只是拿企微账号相关信息
export function getLoginInfoFromApp(callback) {
  window.LoginModule?.getWeworkAcccountInfo((res) => {
    callback && callback(res);
  });
}

/**
 * 通知应用 token过期
 * callback 用户已经重新登录，可以继续流程
 */
export function noticeAppTokenExpired(callback) {
  removeCookie('e2mf',{
    domain:'.xdf.cn'
  });
  removeCookie('e2e',{
    domain:'.xdf.cn'
  });
  removeCookie('identify',{
    domain:'.xdf.cn'
  });
  removeCookie('identify',{
    domain:'xdf.cn'
  });
  window.LoginModule?.tokenExpired((res) => {
    console.log(142, res);
    callback && callback(res);
  });
}

/**
 * 退出登录
 */
export function logout() {
    console.log("退出登录")
    window.LoginModule?.logout();
}

// 从应用中获取设备信息
export function getDeviceInfoFromApp(callback){
  window.bonreeJsBridge&&window.bonreeJsBridge?.setCustomLog("执行 getDeviceInfoFromApp window.DeviceModule" + window.DeviceModule);
  console.log("getDeviceInfoFromApp的 window.DeviceModule" + window.DeviceModule)
  window.bonreeJsBridge&&window.bonreeJsBridge?.setCustomLog("执行 getDeviceInfoFromApp window.DeviceModule?.getDeviceInfo" + window.DeviceModule?.getDeviceInfo);
  console.log("将要执行 getDeviceInfoFromApp的 window.DeviceModule.getDeviceInfo" + window.DeviceModule)
  window.DeviceModule?.getDeviceInfo((res)=>{
    callback && callback(res);
  });
}

// 获取 应用中的storage data:{markKey:kkk}
export function getMarkVersion(data,callback){
  data = JSON.stringify({data:data});
  window.StorageModule?.getMarkVersion(data,(res)=>{
    callback && callback(res);
  });
}
// 更新 应用中的storage data:{markKey:kkk,version:vvv}
export function updateMarkVersion(data){
  data = JSON.stringify({data:data});
  window.StorageModule?.updateMarkVersion(data);
}